export { default, type TableColumnsT, type BuildDataUrlT } from "./PartTable";
